import { Alert, Input, InputNumber, Modal, Space } from "antd"
import { useState } from "react"
import LabeledSwitch from "../../common/LabeledSwitch"
import { rateFractionToPercent, ratePercentToFraction } from "../../../domain/invoicing/taxRate"
import { CreateTaxRateRequest } from "../../../domain/invoicing/taxRatesApi"
import { useCreateTaxRateMutation } from "../../../domain/invoicing/taxRatesQueries"
import { getTaxRateErrors } from "./invoicingSettingsModel"

type Props = {
  isOpen: boolean
  onClose: () => void
  nextSortIndex: number
}

const CreateTaxRateModal = ({ isOpen, onClose, nextSortIndex }: Props) => {
  const defaultValues = (): CreateTaxRateRequest => ({
    name: '',
    rate: 0,
    isDefault: false,
    sortIndex: 0
  })
  
  const [state, setState] = useState<CreateTaxRateRequest>(defaultValues())
  const [errors, setErrors] = useState<string[]>([])
  const createTaxRateMutation = useCreateTaxRateMutation()

  const handleSave = () => {
    const errors = getTaxRateErrors(state)
    setErrors(errors)

    if (errors.length > 0) {
      return
    }

    const data = {
      ...state,
      name: state.name.trim(),
      sortIndex: nextSortIndex
    }
    createTaxRateMutation.mutate(data, {
      onSuccess: () => {
        setState(defaultValues())
        onClose()
      }
    })
  }

  return <Modal
    title="Create Tax Rate"
    open={isOpen}
    onCancel={onClose}
    okText="Save"
    onOk={handleSave}
    okButtonProps={{ disabled: createTaxRateMutation.isLoading, loading: createTaxRateMutation.isLoading }}
    cancelButtonProps={{ disabled: createTaxRateMutation.isLoading }}
  >
    <Space direction="vertical" size="large">
      <Space>
        <div>
          Name
          <br/>
          <Input
            value={state.name}
            onChange={(e) => setState({...state, name: e.target.value})}
            maxLength={100}
          />
        </div>
        <div>
          Rate
          <br/>
          <InputNumber
            addonAfter="%"
            value={rateFractionToPercent(state.rate)}
            onChange={(value) => setState({...state, rate: ratePercentToFraction(value)})}
          />
        </div>
      </Space>
      {errors.length > 0 && <Alert message={errors.map((x, i) => <div key={i}>{x}</div>)} type="error" showIcon={true} />}
      <LabeledSwitch label="Set as Default" value={state.isDefault} onChange={(value) => setState({...state, isDefault: value})} />
    </Space>
  </Modal>
}

export default CreateTaxRateModal
